var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import { ButtonBase } from '../../core/ButtonBase';
export var ButtonComponent = function (props, ref) { return (React.createElement(ButtonBase, __assign({ component: "button", type: "button", ref: ref }, props, { small: false }))); };
/**
 * @tdr-candidates: button
 */
export var Button = forwardRef(ButtonComponent);
//# sourceMappingURL=Button.js.map